<template functional>
  <div>{{ $options.formatterMoney(props.row[props.column]) }}</div>
</template>

<script>
import { formatterMoney } from "@/utils";

export default {
  name: "CelMoney",
  formatterMoney
};
</script>
